import React, { createContext, useState, useContext, useEffect } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const [childMenuOpen, setChildMenuOpen] = useState([]);

  const onClickParentMenu = (menuName) => {
    if (!childMenuOpen.includes(menuName)) {
      setChildMenuOpen((prevStrings) => [...prevStrings, menuName]);
    } else {
      setChildMenuOpen((prevStrings) =>
        prevStrings.filter((str) => str !== menuName)
      );
    }
    if (["Home", "About"].includes(menuName)) toggleSidebar();
  };

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(min-width: 1201px)").matches) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SidebarContext.Provider
      value={{
        isSidebarOpen,
        toggleSidebar,
        childMenuOpen,
        onClickParentMenu,
        setSidebarOpen,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
